var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLightIcon = function SvgCloseLightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.412.238A.826.826 0 0 0 .237.253.843.843 0 0 0 .25 1.438L4.885 6 .25 10.562a.843.843 0 0 0-.013 1.185.826.826 0 0 0 1.175.015l4.663-4.59 4.513 4.442a.826.826 0 0 0 1.175-.014.843.843 0 0 0-.013-1.185L7.265 6l4.485-4.415A.843.843 0 0 0 11.763.4a.826.826 0 0 0-1.175-.014L6.075 4.828 1.412.238Z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseLightIcon;